<div class="org-chart">
  <div class="org-chart-controls">
    <!-- "Anzeige": what boxes and lines show. -->
    <div class="org-chart-display" (click)="$event.stopPropagation()">
      <app-gpd-button
        icon="settings"
        type="text"
        color="var(--color-primary)"
        [hint]="hintDisplay"
        (onClick)="displayMenuOpen = !displayMenuOpen"
      ></app-gpd-button>
      @if (displayMenuOpen) {
        <div class="org-chart-display-menu" role="menu">
          <span class="org-chart-display-title">{{ hintDisplay }}</span>
          @for (option of displayOptions; track option.key) {
            <app-gpd-checkbox [value]="display[option.key]" [label]="option.label" (valueChange)="toggleDisplay(option.key, $event)"></app-gpd-checkbox>
          }
          <!-- Only once a colour was picked in the legend. -->
          @if (hasKindColors) {
            <app-gpd-button type="text" icon="undo" [text]="hintResetKindColors" (onClick)="resetKindColors()"></app-gpd-button>
          }
        </div>
      }
    </div>
    <span class="org-chart-controls-separator" aria-hidden="true"></span>
    <app-gpd-button
      icon="download"
      type="text"
      color="var(--color-primary)"
      [hint]="hintExportPdf"
      [disabled]="!boxes.length || exportingPdf"
      (onClick)="exportPdf()"
    ></app-gpd-button>
    <span class="org-chart-controls-separator" aria-hidden="true"></span>
    <app-gpd-button icon="search-add" type="text" color="var(--color-primary)" [hint]="hintZoomIn" (onClick)="zoomIn()"></app-gpd-button>
    <app-gpd-button icon="search-minus" type="text" color="var(--color-primary)" [hint]="hintZoomOut" (onClick)="zoomOut()"></app-gpd-button>
    <app-gpd-button icon="center-focus" type="text" color="var(--color-primary)" [hint]="hintFit" (onClick)="fit()"></app-gpd-button>
    <!-- Only once a box has been moved by hand. -->
    @if (hasArrangement) {
      <span class="org-chart-controls-separator" aria-hidden="true"></span>
      <app-gpd-button icon="undo" type="text" color="var(--color-primary)" [hint]="hintResetArrangement" (onClick)="resetArrangement()"></app-gpd-button>
    }
  </div>

  <!-- What the lines and the green mark mean, as on the whiteboard. -->
  <div class="org-chart-legend">
    <span class="org-chart-legend-item">
      <!-- The stroke is also the colour picker for this kind of line. -->
      <span class="org-chart-legend-color" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="org-chart-legend-swatch"
          [class.org-chart-legend-swatch--open]="kindColorMenu === 'general'"
          [title]="hintChangeColor"
          [attr.aria-label]="hintChangeColor"
          (click)="toggleKindColorMenu('general')"
        >
          <svg width="40" height="10" aria-hidden="true"><line x1="0" y1="5" x2="40" y2="5" class="org-chart-line org-chart-line--general" [style.stroke]="kindColor('general')" /></svg>
        </button>
        @if (kindColorMenu === 'general') {
          <span class="org-chart-color-picker org-chart-color-picker--legend" role="menu">
            <button type="button" class="org-chart-swatch org-chart-swatch--standard" [class.org-chart-swatch--active]="!kindColor('general')" [title]="hintStandardColor" [attr.aria-label]="hintStandardColor" (click)="setKindColor('general', null)"></button>
            @for (color of lineColorOptions; track color.value) {
              <button type="button" class="org-chart-swatch" [style.background]="color.value" [class.org-chart-swatch--active]="kindColor('general') === color.value" [title]="color.label" [attr.aria-label]="color.label" (click)="setKindColor('general', color.value)"></button>
            }
            @for (color of customColors; track color) {
              <button type="button" class="org-chart-swatch" [style.background]="color" [class.org-chart-swatch--active]="kindColor('general') === color" [title]="color" [attr.aria-label]="color" (click)="setKindColor('general', color)"></button>
            }
            <button type="button" class="org-chart-swatch org-chart-swatch--add" [class.org-chart-swatch--add-open]="customPanel === 'general'" [style.background]="panelPreview('general')" [style.--plus-color]="plusColor(panelPreview('general'))" [title]="hintAddColor" [attr.aria-label]="hintAddColor" [attr.aria-expanded]="customPanel === 'general'" (click)="toggleCustomPanel('general')"></button>
            @if (customPanel === 'general') {
              <app-color-panel
                class="org-chart-color-panel"
                [value]="kindColor('general') ?? '#0984c2'"
                (colorChange)="onPanelColor($event, setKindColorOf('general'))"
              ></app-color-panel>
            }
          </span>
        }
      </span>
      <span i18n="@@societyGeneralPartner">General partner</span>
    </span>
    <span class="org-chart-legend-item">
      <!-- The stroke is also the colour picker for this kind of line. -->
      <span class="org-chart-legend-color" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="org-chart-legend-swatch"
          [class.org-chart-legend-swatch--open]="kindColorMenu === 'limited'"
          [title]="hintChangeColor"
          [attr.aria-label]="hintChangeColor"
          (click)="toggleKindColorMenu('limited')"
        >
          <svg width="40" height="10" aria-hidden="true"><line x1="0" y1="5" x2="40" y2="5" class="org-chart-line org-chart-line--limited" [style.stroke]="kindColor('limited')" /></svg>
        </button>
        @if (kindColorMenu === 'limited') {
          <span class="org-chart-color-picker org-chart-color-picker--legend" role="menu">
            <button type="button" class="org-chart-swatch org-chart-swatch--standard" [class.org-chart-swatch--active]="!kindColor('limited')" [title]="hintStandardColor" [attr.aria-label]="hintStandardColor" (click)="setKindColor('limited', null)"></button>
            @for (color of lineColorOptions; track color.value) {
              <button type="button" class="org-chart-swatch" [style.background]="color.value" [class.org-chart-swatch--active]="kindColor('limited') === color.value" [title]="color.label" [attr.aria-label]="color.label" (click)="setKindColor('limited', color.value)"></button>
            }
            @for (color of customColors; track color) {
              <button type="button" class="org-chart-swatch" [style.background]="color" [class.org-chart-swatch--active]="kindColor('limited') === color" [title]="color" [attr.aria-label]="color" (click)="setKindColor('limited', color)"></button>
            }
            <button type="button" class="org-chart-swatch org-chart-swatch--add" [class.org-chart-swatch--add-open]="customPanel === 'limited'" [style.background]="panelPreview('limited')" [style.--plus-color]="plusColor(panelPreview('limited'))" [title]="hintAddColor" [attr.aria-label]="hintAddColor" [attr.aria-expanded]="customPanel === 'limited'" (click)="toggleCustomPanel('limited')"></button>
            @if (customPanel === 'limited') {
              <app-color-panel
                class="org-chart-color-panel"
                [value]="kindColor('limited') ?? '#0984c2'"
                (colorChange)="onPanelColor($event, setKindColorOf('limited'))"
              ></app-color-panel>
            }
          </span>
        }
      </span>
      <span i18n="@@societyLimitedPartner">Limited partner</span>
    </span>
    <span class="org-chart-legend-item">
      <!-- The stroke is also the colour picker for this kind of line. -->
      <span class="org-chart-legend-color" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="org-chart-legend-swatch"
          [class.org-chart-legend-swatch--open]="kindColorMenu === 'plain'"
          [title]="hintChangeColor"
          [attr.aria-label]="hintChangeColor"
          (click)="toggleKindColorMenu('plain')"
        >
          <svg width="40" height="10" aria-hidden="true"><line x1="0" y1="5" x2="40" y2="5" class="org-chart-line" [style.stroke]="kindColor('plain')" /></svg>
        </button>
        @if (kindColorMenu === 'plain') {
          <span class="org-chart-color-picker org-chart-color-picker--legend" role="menu">
            <button type="button" class="org-chart-swatch org-chart-swatch--standard" [class.org-chart-swatch--active]="!kindColor('plain')" [title]="hintStandardColor" [attr.aria-label]="hintStandardColor" (click)="setKindColor('plain', null)"></button>
            @for (color of lineColorOptions; track color.value) {
              <button type="button" class="org-chart-swatch" [style.background]="color.value" [class.org-chart-swatch--active]="kindColor('plain') === color.value" [title]="color.label" [attr.aria-label]="color.label" (click)="setKindColor('plain', color.value)"></button>
            }
            @for (color of customColors; track color) {
              <button type="button" class="org-chart-swatch" [style.background]="color" [class.org-chart-swatch--active]="kindColor('plain') === color" [title]="color" [attr.aria-label]="color" (click)="setKindColor('plain', color)"></button>
            }
            <button type="button" class="org-chart-swatch org-chart-swatch--add" [class.org-chart-swatch--add-open]="customPanel === 'plain'" [style.background]="panelPreview('plain')" [style.--plus-color]="plusColor(panelPreview('plain'))" [title]="hintAddColor" [attr.aria-label]="hintAddColor" [attr.aria-expanded]="customPanel === 'plain'" (click)="toggleCustomPanel('plain')"></button>
            @if (customPanel === 'plain') {
              <app-color-panel
                class="org-chart-color-panel"
                [value]="kindColor('plain') ?? '#0984c2'"
                (colorChange)="onPanelColor($event, setKindColorOf('plain'))"
              ></app-color-panel>
            }
          </span>
        }
      </span>
      <span i18n="@@societyShareholder">Shareholder</span>
    </span>
  </div>

  <div
    #viewport
    class="org-chart-viewport"
    [class.org-chart-viewport--dragging]="drag?.moved || boxDrag?.moved"
    (wheel)="onWheel($event)"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (click)="onViewportClick()"
  >
    @if (boxes.length) {
      <div class="org-chart-canvas" [style.width.px]="layout.width" [style.height.px]="layout.height" [style.transform]="transform">
        <!-- Verkaufsmodelle: a labelled area behind their boxes. -->
        @for (band of display.bands ? bands : []; track band.band + ':' + band.level + ':' + band.keys[0]) {
          <div class="org-chart-band" [style.left.px]="band.x" [style.top.px]="band.y" [style.width.px]="band.width" [style.height.px]="band.height">
            <span class="org-chart-band-label" [style.height.px]="bandLabelHeight">{{ band.label }}</span>
          </div>
        }

        <!-- USt.: frames around the umsatzsteuerpflichtigen Gesellschaften, as on the whiteboard; as
             many as needed so that none holds a Gesellschaft that isn't. -->
        @for (frame of vatFrames; track $index) {
          <div class="org-chart-vat-area" [style.left.px]="frame.x" [style.top.px]="frame.y" [style.width.px]="frame.width" [style.height.px]="frame.height">
            <span class="org-chart-vat-area-label">{{ vatAreaLabel }}</span>
          </div>
        }

        <svg class="org-chart-lines" [attr.width]="layout.width" [attr.height]="layout.height" aria-hidden="true">
          @for (line of lines; track trackLine($index, line)) {
            <path
              [attr.d]="line.path"
              class="org-chart-line"
              [class.org-chart-line--general]="line.role === 'general_partner'"
              [class.org-chart-line--limited]="line.role === 'limited_partner'"
              [style.stroke]="colorOf(line)"
              [class.org-chart-line--active]="(selectedKey && isLineRelated(line)) || selectedLineId === line.id"
              [class.org-chart-line--dimmed]="(selectedKey && !isLineRelated(line)) || (selectedLineId && selectedLineId !== line.id)"
            ></path>
          }
          <!-- Wider, invisible copies on top: easier to hit. A click selects the line to reshape it. -->
          @for (line of lines; track trackLine($index, line)) {
            <path [attr.d]="line.path" class="org-chart-line-hit" (click)="onLineClick(line, $event)"></path>
          }
        </svg>

        @for (line of lines; track trackLine($index, line)) {
          <!-- Only a line with a share is labelled; a Komplementär without capital is told by its stroke (legend). -->
          @if (display.shares && hasShare(line)) {
            <span
              class="org-chart-share"
              [class.org-chart-share--general]="line.role === 'general_partner'"
              [style.borderColor]="colorOf(line)"
              [style.color]="colorOf(line)"
              [class.org-chart-share--dimmed]="selectedKey && !isLineRelated(line)"
              [class.org-chart-share--active]="selectedKey === line.to"
              [style.left.px]="line.labelX"
              [style.top.px]="labelTop(line)"
              [title]="lineTitle(line)"
            >{{ lineLabel(line) }}</span>
          }
        }

        @for (box of boxes; track trackBox($index, box)) {
          <button
            type="button"
            class="org-chart-box"
            [class.org-chart-box--society]="box.node.type === 'society'"
            [class.org-chart-box--dimmed]="isDimmed(box)"
            [class.org-chart-box--match]="isHighlighted(box)"
            [class.org-chart-box--selected]="selectedKey === box.key"
            [class.org-chart-box--dragging]="boxDrag?.moved && boxDrag?.key === box.key"
            [attr.aria-pressed]="selectedKey === box.key"
            [style.left.px]="box.x"
            [style.top.px]="box.y"
            [style.width.px]="box.width"
            [style.height.px]="nodeHeight"
            [title]="boxTitle(box)"
            (pointerdown)="onBoxPointerDown(box, $event)"
            (click)="onBoxClick(box, $event)"
            (dblclick)="open(box)"
            (keydown.enter)="open(box)"
          >
            <!-- Gesellschaften need no icon (their green border marks them); companies and persons have one. -->
            @if (box.node.type !== 'society') {
              <app-svg-icon [icon]="box.node.type === 'company' ? 'building' : 'user'" [size]="20" color="var(--color-grey-600)"></app-svg-icon>
            }
            <span class="org-chart-box-text">
              <span class="org-chart-box-name">{{ box.node.name }}</span>
              <!-- A Gesellschaft shows its Geschäftsführung here; without one, and for companies
                   and persons, the kind of box. -->
              @if (directorsOf(box.node).length) {
                <span class="org-chart-box-type"><span class="org-chart-box-directors-label">{{ directorsLabel }}</span> {{ directorsOf(box.node).join(', ') }}</span>
              } @else {
                <span class="org-chart-box-type">{{ typeLabels[box.node.type] }}</span>
              }
              <!-- Zuständiger Buchhalter and its Vertretung. -->
              @if (accountantParts(box.node); as parts) {
                @if (parts.length) {
                  <span class="org-chart-box-type org-chart-box-accountant">
                    @for (part of parts; track part.label) {
                      <span><span class="org-chart-box-directors-label">{{ part.label }}</span> {{ part.name }}</span>
                    }
                  </span>
                }
              }
            </span>
          </button>
        }

        <!-- The selected line once more, above boxes and bands, so it can be followed all the way. -->
        @if (selectedLine; as line) {
          <svg class="org-chart-lines org-chart-lines--front" [attr.width]="layout.width" [attr.height]="layout.height" aria-hidden="true">
            <path
              [attr.d]="line.path"
              class="org-chart-line org-chart-line--active"
              [style.stroke]="colorOf(line)"
              [class.org-chart-line--general]="line.role === 'general_partner'"
              [class.org-chart-line--limited]="line.role === 'limited_partner'"
            ></path>
          </svg>
        }

        <!-- Selected line: a handle per segment, dragged across it like an elbow connector in Miro. -->
        @for (handle of lineHandles; track handle.index) {
          <span
            class="org-chart-line-handle"
            [class.org-chart-line-handle--vertical]="handle.vertical"
            [style.left.px]="handle.x"
            [style.top.px]="handle.y"
            [title]="hintMoveSegment"
            (pointerdown)="onHandlePointerDown(handle.index, $event)"
            (click)="$event.stopPropagation()"
          ></span>
        }

        <!-- Opens the selected box (a click only selects it); in the gap to its right. -->
        @if (selectedBox; as box) {
          @if (!demo) {
            <button
              type="button"
              class="org-chart-open"
              [style.left.px]="box.x + box.width + 4"
              [style.top.px]="box.y + nodeHeight / 2 - 12"
              [title]="hintOpen"
              [attr.aria-label]="hintOpen + ' ' + box.node.name"
              (click)="$event.stopPropagation(); open(box)"
            >
              <app-svg-icon icon="arrow-right" [size]="16" color="var(--color-white)"></app-svg-icon>
            </button>
          }
        }
      </div>
      <!-- Colour of the selected line, above it; in screen pixels, so it keeps its size at any zoom. -->
      @if (lineToolbarPosition; as pos) {
        <div
          class="org-chart-color-picker org-chart-color-picker--line"
          role="toolbar"
          [attr.aria-label]="hintLineColor"
          [style.left.px]="pos.left"
          [style.top.px]="pos.top"
          (pointerdown)="$event.stopPropagation()"
          (click)="$event.stopPropagation()"
        >
          <button type="button" class="org-chart-swatch org-chart-swatch--standard" [class.org-chart-swatch--active]="!lineColors[selectedLineId!]" [title]="hintStandardColor" [attr.aria-label]="hintStandardColor" (click)="setLineColor(null)"></button>
          @for (color of lineColorOptions; track color.value) {
            <button type="button" class="org-chart-swatch" [style.background]="color.value" [class.org-chart-swatch--active]="lineColors[selectedLineId!] === color.value" [title]="color.label" [attr.aria-label]="color.label" (click)="setLineColor(color.value)"></button>
          }
          @for (color of customColors; track color) {
            <button type="button" class="org-chart-swatch" [style.background]="color" [class.org-chart-swatch--active]="lineColors[selectedLineId!] === color" [title]="color" [attr.aria-label]="color" (click)="setLineColor(color)"></button>
          }
          <button type="button" class="org-chart-swatch org-chart-swatch--add" [class.org-chart-swatch--add-open]="customPanel === 'line'" [style.background]="panelPreview('line')" [style.--plus-color]="plusColor(panelPreview('line'))" [title]="hintAddColor" [attr.aria-label]="hintAddColor" [attr.aria-expanded]="customPanel === 'line'" (click)="toggleCustomPanel('line')"></button>
          @if (customPanel === 'line') {
            <app-color-panel
              class="org-chart-color-panel"
              [value]="lineColors[selectedLineId!] ?? '#0984c2'"
              (colorChange)="onPanelColor($event, applyToSelectedLine)"
            ></app-color-panel>
          }
        </div>
      }
    } @else {
      <p class="org-chart-empty" i18n="@@societiesNoData">Noch keine Gesellschaften</p>
    }
  </div>
</div>
